// extracted by mini-css-extract-plugin
export var control = "style-module--control--20fsW";
export var controlDark = "style-module--control-dark--3aRMj";